import { useCurrentLanguage, useTranslator } from 'tradera/lang/translate';
import AppstoreBadgeEn from 'tradera/blueprint/theme/logos/app-store-badge-en.svg?next-image';
import AppstoreBadgeSv from 'tradera/blueprint/theme/logos/app-store-badge-sv.svg?next-image';
import AppstoreBadgeDa from 'tradera/blueprint/theme/logos/app-store-badge-da.svg?next-image';
import AppstoreBadgeDe from 'tradera/blueprint/theme/logos/app-store-badge-de.svg?next-image';
import AppstoreBadgeNl from 'tradera/blueprint/theme/logos/app-store-badge-nl.svg?next-image';
import AppstoreBadgeFr from 'tradera/blueprint/theme/logos/app-store-badge-fr.svg?next-image';
import GooglePlayBadgeEn from 'tradera/blueprint/theme/logos/google-play-badge-en.svg?next-image';
import GooglePlayBadgeSv from 'tradera/blueprint/theme/logos/google-play-badge-sv.svg?next-image';
import GooglePlayBadgeDa from 'tradera/blueprint/theme/logos/google-play-badge-da.svg?next-image';
import GooglePlayBadgeDe from 'tradera/blueprint/theme/logos/google-play-badge-de.svg?next-image';
import GooglePlayBadgeNl from 'tradera/blueprint/theme/logos/google-play-badge-nl.svg?next-image';
import GooglePlayBadgeFr from 'tradera/blueprint/theme/logos/google-play-badge-fr.svg?next-image';

type BadgeMap = {
    [key: string]: string | undefined;
};

const googlePlayBadges: BadgeMap = {
    sv: GooglePlayBadgeSv,
    da: GooglePlayBadgeDa,
    de: GooglePlayBadgeDe,
    fr: GooglePlayBadgeFr,
    nl: GooglePlayBadgeNl,
    en: GooglePlayBadgeEn
};

export const GooglePlayBadge = ({ height = '30' }) => {
    const { language } = useCurrentLanguage();
    const { t } = useTranslator();

    const badge = googlePlayBadges[language] ?? googlePlayBadges['en'];

    return (
        <img
            src={badge}
            loading="lazy"
            height={height}
            title={t('footer_downloadFromAppStore', {
                appName: 'Google Play'
            })}
            alt={t('footer_downloadFromAppStore', {
                appName: 'Google Play'
            })}
        />
    );
};

const appleStoreBadges: BadgeMap = {
    sv: AppstoreBadgeSv,
    da: AppstoreBadgeDa,
    de: AppstoreBadgeDe,
    fr: AppstoreBadgeFr,
    nl: AppstoreBadgeNl,
    en: AppstoreBadgeEn
};

type AppstoreProps = {
    height?: string;
    className?: string;
};

export const AppstoreBadge = ({ height = '30', className }: AppstoreProps) => {
    const { language } = useCurrentLanguage();
    const { t } = useTranslator();

    const badge = appleStoreBadges[language] ?? googlePlayBadges['en'];

    return (
        <img
            src={badge}
            loading="lazy"
            height={height}
            className={className}
            title={t('footer_downloadFromAppStore', {
                appName: 'App Store'
            })}
            alt={t('footer_downloadFromAppStore', {
                appName: 'App Store'
            })}
        />
    );
};
